import { onUnmounted } from "vue";
import { AxiosError, AxiosResponse } from "axios";
import { Store, useStore } from "vuex";
import { getCustomer } from "@/apps/merchant3/services/customers.service";
import { ICustomerWrap } from "@/types/customer";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";

export default function useIntervalCustomerState(
  keepPolling = 1,
  callback?: () => void,
  storeInstance?: Store<IVuexState>
): void {
  const store = storeInstance || useStore();

  const getCustomerData = async (userTag: string | null | undefined) => {
    if (!userTag || userTag === "undefined") {
      return;
    }

    try {
      const response: AxiosResponse<ICustomerWrap> = await getCustomer(userTag);
      store.dispatch("customer/setCustomer", response.data?.customer);
      if (callback) callback();
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.response?.data) {
        switch (axiosError.response.data.errorCode) {
          case 10206:
            await store.dispatch("carts/loadCart", store.state.carts.cartTag);
            if (store.state.carts.userTag) {
              sessionStorage.setItem("PJ_userTag", store.state.carts.userTag);
            }
            break;
          default:
            break;
        }
      }
    }
  };

  const getUserTag = (): null | string => {
    if (
      store.state.carts?.userTag &&
      store.state.carts.userTag !== "undefined"
    ) {
      return store.state.carts.userTag;
    }
    const sessionUserTag = sessionStorage.getItem("PJ_userTag") as string;

    if (sessionUserTag && sessionUserTag !== "undefined") {
      return sessionUserTag;
    }

    return null;
  };

  if (keepPolling == 1) {
    const interval: number = setInterval(() => {
      const userTag = getUserTag();

      getCustomerData(userTag);
    }, 5000);

    onUnmounted(() => {
      clearInterval(interval);
    });
  } else {
    const userTag = getUserTag();

    getCustomerData(userTag);
  }
}
